// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1274":"a4fe211c","8203":"f23c84a3"}[chunkId] + ".chunk.css";
};